import React from "react";

import { Text } from "@ui/Atoms";

import * as Styled from "./City.styled";

type City = {
  image_caption: { text?: string | null };
  city_image?: { alt?: string | null; gatsbyImageData?: any | null } | null;
  service_link?: { slug?: string | null } | null;
};

export const City: React.FC<{ city: City }> = ({ city }) => {
  return (
    <Styled.Root>
      {city.service_link?.slug && (
        <Styled.AnchorOverlay href={city.service_link.slug} />
      )}
      <Styled.ImageWrapper>
        <Styled.Image
          alt={city.city_image?.alt || ""}
          image={city.city_image?.gatsbyImageData}
        />
      </Styled.ImageWrapper>
      <Text
        as="p"
        $color="grey800"
        $style={{ default: "bold_24", smallDesktop: "bold_28" }}
      >
        {city.image_caption?.text}
      </Text>
    </Styled.Root>
  );
};
